import {
    bpsUrl
} from "@common/url-conf";

import {
    post
} from "@common/axios";
export const openApi = {
    //获取table组件表头信息
    getTableHeader: (p) => post(`${bpsUrl}/api/v1/dynamicheader/querydynamicheaderset`, { busiCode: window.location.pathname + p }),
    saveTableHeader: (p) => post(`${bpsUrl}/api/v1/dynamicheader/savedynamicheaderset`, p)
};



// WEBPACK FOOTER //
// ./src/components/Table/services.js